module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tool-wrap"
  }, [_c('button', {
    staticClass: "tool__button",
    on: {
      "click": _vm.openPanel
    }
  }, [_c('Icon', {
    attrs: {
      "icon": this.icon
    }
  }), _c('span', {
    staticClass: "tool__button-text"
  }, [_vm._v(_vm._s(_vm.title))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-714b4658!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tool.vue
// module id = 327
// module chunks = 0